import script from "./BaseSpinnerCircle.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSpinnerCircle.vue?vue&type=script&setup=true&lang=js"

import "./BaseSpinnerCircle.vue?vue&type=style&index=0&id=9bad4c5a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bad4c5a"]])

export default __exports__